import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import MessageContext from './MessageContext';
import { ReactQueryDevToolProvider } from './ReactQueryDevToolProvider';
import { SilentProvider } from './Silent';

export const ReactQueryProvider = ({
  children,
  showErrorMessage,
  showSuccessMessage,
  showMessage,
}) => {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          retry: false,
          queries: {
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
          },
        },
      }),
    []
  );

  return (
    <MessageContext.Provider
      value={{ showErrorMessage, showSuccessMessage, showMessage }}
    >
      <SilentProvider>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevToolProvider>{children}</ReactQueryDevToolProvider>
        </QueryClientProvider>
      </SilentProvider>
    </MessageContext.Provider>
  );
};
